module.exports = __webpack_public_path__ + "media/images/homes/Inbuild_Themes-635211874bca690a9420ef102876fb24.png";